<template>
  <div id="app" v-loading="isLoading" element-loading-background="rgba(0,0,0,0)">
    <layout>
      <router-view v-if="isRouterAlive"></router-view>
    </layout>
  </div>
</template>

<script>
import layout from './components/layout/index'
import { parentOrigin } from '~/router/index'
export default {
  name: 'App',
  provide () {
    return {
      $_reload: this.$_reload,
      $showLoading: this.$showLoading,
      $hideLoading: this.$hideLoading
    }
  },
  data () {
    return {
      isRouterAlive: true,
      isLoading: false
    }
  },
  computed: {
    isXueshi () {
      return this.$route.path.indexOf('/xueshi-iJournal') === 0
    }
  },
  components: {
    layout
  },
  mounted () {
    if (this.isXueshi) {
      window.addEventListener('message', this.onMessage, false)
    }
  },
  methods: {
    $_reload () {
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true
      })
    },
    $showLoading () {
      this.isLoading = true
    },
    $hideLoading () {
      this.isLoading = false
    },
    // 接受父页面的消息
    onMessage (e) {
      if (e.origin !== parentOrigin) {
        return
      }
      if (e.data.type === 'pushRouter') {
        this.$router.push(e.data.target)
      }
    }
  },
  watch: {
    isXueshi (newValue) {
      if (!newValue) {
        window.removeEventListener('message', this.onMessage, false)
      }
      window.addEventListener('message', this.onMessage, false)
    }
  }
}
</script>

<style lang="scss">
 #app {
   width: 100%;
   height: 100%;
 }
@import './style/index.scss';
@import url('//at.alicdn.com/t/font_1548836_ogfpsjkpu8b.css');
// @import './style/iconfont/iconfont.css';
</style>



// WEBPACK FOOTER //
// src/App.vue